import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const ShowcaseIconSvg: FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <mask
        id="mask0_517_8301"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="8"
        width="24"
        height="24"
      >
        <rect y="8" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_517_8301)">
        <path
          d="M5.3077 28.5C4.80257 28.5 4.375 28.325 4.025 27.975C3.675 27.625 3.5 27.1974 3.5 26.6923V13.3077C3.5 12.8026 3.675 12.375 4.025 12.025C4.375 11.675 4.80257 11.5 5.3077 11.5H15.7884L20.5 16.2115V26.6923C20.5 27.1974 20.325 27.625 19.975 27.975C19.625 28.325 19.1974 28.5 18.6923 28.5H5.3077ZM5.3077 27H18.6923C18.782 27 18.8557 26.9711 18.9134 26.9134C18.9711 26.8557 19 26.782 19 26.6923V17H15V13H5.3077C5.21795 13 5.14423 13.0288 5.08653 13.0865C5.02883 13.1442 4.99997 13.218 4.99997 13.3077V26.6923C4.99997 26.782 5.02883 26.8557 5.08653 26.9134C5.14423 26.9711 5.21795 27 5.3077 27ZM7.25 24.5H16.75V23H7.25V24.5ZM7.25 17H12V15.5H7.25V17ZM7.25 20.75H16.75V19.25H7.25V20.75Z"
          fill="#757575"
        />
      </g>
      <rect x="9" width="23" height="23" fill="white" stroke="transparent" />
      <mask
        id="mask1_517_8301"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="1"
        width="24"
        height="24"
      >
        <rect x="7" y="1" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_517_8301)">
        <path
          d="M16.6923 17.0384L22.9807 13L16.6923 8.96155V17.0384ZM12.3077 21.5C11.8026 21.5 11.375 21.325 11.025 20.975C10.675 20.625 10.5 20.1974 10.5 19.6923V6.3077C10.5 5.80257 10.675 5.375 11.025 5.025C11.375 4.675 11.8026 4.5 12.3077 4.5H25.6923C26.1974 4.5 26.625 4.675 26.975 5.025C27.325 5.375 27.5 5.80257 27.5 6.3077V19.6923C27.5 20.1974 27.325 20.625 26.975 20.975C26.625 21.325 26.1974 21.5 25.6923 21.5H12.3077ZM12.3077 20H25.6923C25.7692 20 25.8397 19.9679 25.9038 19.9038C25.9679 19.8397 26 19.7692 26 19.6923V6.3077C26 6.23077 25.9679 6.16024 25.9038 6.09613C25.8397 6.03203 25.7692 5.99998 25.6923 5.99998H12.3077C12.2308 5.99998 12.1602 6.03203 12.0961 6.09613C12.032 6.16024 12 6.23077 12 6.3077V19.6923C12 19.7692 12.032 19.8397 12.0961 19.9038C12.1602 19.9679 12.2308 20 12.3077 20Z"
          fill="#757575"
        />
      </g>
    </svg>
  )
}

export const ShowcaseIcon = createStandardIcon(ShowcaseIconSvg)
